// extracted by mini-css-extract-plugin
module.exports = {"dateGroups":"reports_dateGroups__N4oQZ","dateLabel":"reports_dateLabel__3kTe_","reportList":"reports_reportList__35KmR","pagination":"reports_pagination__1jCco"};